import { Language } from "@/lib";
import { z } from "zod";

const lang = document.documentElement.lang as Language;

export const errorMessages = {
  en: {
    regionRequired: "Region is required",
    emirateRequired: "Emirate is required",
    dateRequired: "Choose a Date",
    slotRequired: "Please select a Slot",
    nameRequired: "Name is required",
    emailRequired: "Email is required",
    emailInvalid: "Enter a valid email address",
    phoneRequired: "Phone is required",
    addressRequired: "Address is required",
  },
  ar: {
    regionRequired: "المنطقة مطلوبة",
    emirateRequired: "الإمارة مطلوبة",
    dateRequired: "اختر تاريخاً",
    slotRequired: "الرجاء اختيار موعد",
    nameRequired: "الاسم مطلوب",
    emailRequired: "البريد الإلكتروني مطلوب",
    emailInvalid: "أدخل عنوان بريد إلكتروني صحيح",
    phoneRequired: "رقم الهاتف مطلوب",
    addressRequired: "العنوان مطلوب",
  },
} as const;

export const scheduleFormSchema = z.object({
  region: z.string({ required_error: errorMessages[lang].regionRequired }),
  emirate: z.string({ required_error: errorMessages[lang].emirateRequired }),
  date: z.coerce.date({ required_error: errorMessages[lang].dateRequired }),
  startDateTime: z.string().optional(), // or .datetime() or z.coerce.date().optional()
  duration: z.number({ required_error: errorMessages[lang].slotRequired }),
  name: z.string({ required_error: errorMessages[lang].nameRequired }),
  email: z
    .string({ required_error: errorMessages[lang].emailRequired })
    .min(1, { message: errorMessages[lang].emailRequired })
    .email({ message: errorMessages[lang].emailInvalid }),
  phone: z.string({ required_error: errorMessages[lang].phoneRequired }),
  address: z.string({ required_error: errorMessages[lang].addressRequired }),
});

export type ScheduleFormData = z.infer<typeof scheduleFormSchema>;
